<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button text="" (click)="back()"></ion-back-button>
    </ion-buttons>
    <ion-title>Feedback geben</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <p>Wir freuen uns über Ihr Feedback! Hier haben Sie die Möglichkeit, uns Ihre Anregungen und Kritik mitzuteilen. Wir sind stets bemüht, unseren Service zu verbessern und nehmen Ihre Meinung sehr ernst.</p>
  <h2>Wie würden Sie die Webversion des AFS-Ticketsystem bewerten?</h2>
  <div id="smileys">
    <div class="smiley" [class.active]="criticism.rate == 1" (click)="criticism.rate = 1"><div>😡</div></div>
    <div class="smiley" [class.active]="criticism.rate == 2" (click)="criticism.rate = 2"><div>🙁</div></div>
    <div class="smiley" [class.active]="criticism.rate == 3" (click)="criticism.rate = 3"><div>😐</div></div>
    <div class="smiley" [class.active]="criticism.rate == 4" (click)="criticism.rate = 4"><div>🙂</div></div>
    <div class="smiley" [class.active]="criticism.rate == 5" (click)="criticism.rate = 5"><div>😍</div></div>
  </div>
  <h2>Bitte geben Sie jegliche Kritik und Verbesserungsvorschläge an.</h2>
  <textarea [(ngModel)]="criticism.text" placeholder="Feedback angeben..."></textarea>

  <div id="anonymous">
    <ion-checkbox [(ngModel)]="criticism.anonymousChecked" slot="start"></ion-checkbox>
    <h2 (click)="criticism.anonymousChecked = !criticism.anonymousChecked">Feedback anonym senden</h2>
  </div>
  <ion-input *ngIf="!criticism.anonymousChecked" [(ngModel)]="criticism.emailAddress" id="anonymousInput" placeholder="E-Mail-Adresse..." style="--padding-start: 10px"></ion-input>
</ion-content>

<ion-footer>
  <ion-toolbar class="ion-padding">
      <ion-button mode="ios" (click)="sendMail()" style="box-shadow: none">Feedback abgeben</ion-button>
  </ion-toolbar>
</ion-footer>
